// take the amount as argument and return with currency and format of decimal places
const formatExchangeRate = (amount) => {
  if (!amount && amount !== 0) {
    return ''
  }
  return `${Math.round((amount + Number.EPSILON) * 10000) / 10000} PLN`
}

export default formatExchangeRate
